import React, { ReactElement } from 'react';
import { type TFunction } from 'i18next';

import { FullTalentQuestionDTOType } from '@/api/generated';
import CalendarIcon from '@/assets/icons/calendar.svg?react';
import CheckBoxIcon from '@/assets/icons/checkbox.svg?react';
import DropdownIcon from '@/assets/icons/dropdown.svg?react';
// import FileIcon from '@/assets/icons/file.svg?react';
import LongTextIcon from '@/assets/icons/long-text.svg?react';
import MultiChoiceIcon from '@/assets/icons/multichoice.svg?react';
import ShortTextIcon from '@/assets/icons/short-text.svg?react';
import { DropdownSelectOption } from '@/components/fields/DropdownSelect';

export const getQuestionTypes = (t: TFunction /*, isExternal: boolean */): DropdownSelectOption[] =>
  [
    {
      label: t('orgSettings.talentRegistrationForm.questionType.text'),
      value: FullTalentQuestionDTOType.TEXT,
      Icon: <ShortTextIcon />
    },
    {
      label: t('orgSettings.talentRegistrationForm.questionType.longText'),
      value: FullTalentQuestionDTOType.LONG_TEXT,
      Icon: <LongTextIcon />
    },
    {
      label: t('orgSettings.talentRegistrationForm.questionType.checkbox'),
      value: FullTalentQuestionDTOType.CHECKBOX,
      Icon: <CheckBoxIcon />
    },
    {
      label: t('orgSettings.talentRegistrationForm.questionType.radio'),
      value: FullTalentQuestionDTOType.RADIO,
      Icon: <MultiChoiceIcon />
    },
    {
      label: t('orgSettings.talentRegistrationForm.questionType.select'),
      value: FullTalentQuestionDTOType.SELECT,
      Icon: <DropdownIcon />
    },
    // FIXME: delete or uncomment when enum FILE value is clarified what to do with
    // isExternal && {
    //   label: t('orgSettings.talentRegistrationForm.questionType.file'),
    //   value: FullTalentQuestionDTOType.FILE,
    //   Icon: <FileIcon />
    // },
    {
      label: t('orgSettings.talentRegistrationForm.questionType.year'),
      value: FullTalentQuestionDTOType.YEAR,
      Icon: <CalendarIcon />
    }
  ].filter((item): item is { label: string; value: FullTalentQuestionDTOType; Icon: ReactElement } => Boolean(item));
